module.exports = "/_next/static/images/super-c854315fd1aa5a2ae0bb02a51bc93535.png";